import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-calendar-dialog',
    templateUrl: './calendar-dialog.component.html',
    styleUrls: ['./calendar-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class CalendarDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.add('broadcast-dialog_overlay');
  }

  ngOnInit(): void {
  }

}
